export default "skymp5-front/0950363d06b229bb4db43b65b07849a2.gif";